export default {"src":"/_next/static/media/snm.f2250bdb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};